import { Service } from 'modules/services';
import { Shop } from 'modules/shops';
import { DropdownOption } from '../../../inputs/select';

/**
 * Возвращает список магазинов для выпадающего списка
 * @param {Service[] | undefined} serviceList
 * @param {Shop | undefined} shopList
 * @returns {DropdownOption[]}
 */
export const getShopDropdownList = (
  serviceList: Service[] | undefined,
  shopList: Shop | undefined
): DropdownOption[] => {
  if (!serviceList || !shopList) {
    return [];
  }

  return serviceList
    .filter(({ isSaleable, location }: Service) => isSaleable && location.name.split(' ')[0] === 'ЛМ')
    .map(({ location }: Service) => ({
      value: location.storeCode,
      text: shopList[location.storeCode].name.values[0],
    }));
};
